import "./privacy.css";

const TermsOfUsage = () => {
  return (
    <div className="termsContainer atl_content legal_pp">
      <div className="one_line_col">
        <h2 className="t-center t-underline">TERMS OF USE</h2>
        <p>
          These Terms of Use (this <strong>“Agreement”</strong>) concern the
          websites (together with their respective pages and features, the{" "}
          <strong>“Site”</strong>) and mobile software applications (together
          with their respective pages and features, the <strong>“App”</strong>
          and, together with the Site, the <strong>“Platform”</strong>)
          operated, hosted, and/or published by Atlas Energy Solutions (together
          with its affiliates, <strong>“Company”</strong>) and all associated
          services and products provided on, through, or in relation to the
          Platform (the <strong>“Services”</strong>). This Agreement is made and
          entered into by and between you and any person helping you access or
          use the Platform or the Services, whether as a guest or a registered
          user (collectively, “<strong>you</strong>” or <strong>“your”</strong>
          ), on the one side, and Company on the other side. You and Company are
          sometimes referred to herein, individually, as a{" "}
          <strong>“Party”</strong> and, collectively, as the{" "}
          <strong>“Parties.”</strong>
        </p>
        <p>
          PLEASE READ THIS AGREEMENT CAREFULLY BEFORE ACCESSING OR USING THE
          PLATFORM AND/OR THE SERVICES BECAUSE IT CONSTITUTES A LEGALLY BINDING
          CONTRACT BETWEEN YOU AND COMPANY. THIS INCLUDES THE “DISPUTE
          RESOLUTION” CLAUSE CONTAINED IN THIS AGREEMENT, WHICH PROVIDES FOR
          BINDING ARBITRATION AND WAIVERS OF JURY TRIALS AND CLASS ACTIONS.
        </p>
        <p>
          YOU ARE AUTOMATICALLY ACCEPTING AND AGREEING TO THE MOST RECENT
          VERSION OF THIS AGREEMENT WHENEVER YOU ACCESS OR USE THE PLATFORM OR
          THE SERVICES, AND YOUR CONTINUING ACCESS OR USE OF ANY OF THE
          FOREGOING REAFFIRMS YOUR ACCEPTANCE AND AGREEMENT IN EACH INSTANCE. IF
          YOU DO NOT ACCEPT AND AGREE TO THIS AGREEMENT IN ITS ENTIRETY, THEN
          YOU ARE STRICTLY PROHIBITED FROM ACCESSING OR USING THE PLATFORM OR
          THE SERVICES.
        </p>
        <p>
          COMPANY MAY SUPPLEMENT, AMEND OR OTHERWISE MODIFY THIS AGREEMENT AT
          ANY TIME. SUCH MODIFICATIONS WILL BE POSTED ON THIS OR ANOTHER PAGE OF
          THE PLATFORM, AS COMPANY DEEMS APPROPRIATE IN ITS SOLE DISCRETION, AND
          SUCH MODIFICATIONS SHALL BE DEEMED EFFECTIVE AS OF THEIR STATED
          EFFECTIVE OR MODIFICATION DATES. IT IS YOUR RESPONSIBILITY TO
          CAREFULLY REVIEW THIS AGREEMENT EACH TIME YOU ACCESS OR USE THE
          PLATFORM OR THE SERVICES.
        </p>
      </div>
      <div className="one_line_col">
        <ol type="1" id="list-auto">
          <li>
            <p>
              <strong className="t-underline">Eligibility.</strong> The Platform
              is offered only to users 18 years of age or older, or otherwise
              the age of majority in each user’s respective jurisdiction, and
              who have accepted this Agreement. By accessing or using the
              Platform or the Services, you represent and warrant to Company
              that you meet these eligibility requirements. You agree to comply
              with all applicable laws for accessing and using the Platform or
              the Services.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Privacy.</strong> Company respects
              the privacy of others. Company’s policies concerning the
              collection and use of your personal information in connection with
              the Platform are set forth in the Platform’s Privacy Policy, which
              you should carefully review each time you access or use the
              Platform or the Services.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Your Devices.</strong> Certain
              portions of the Platform may be configured for, and Company may
              offer the Platform through, certain computers, tablets, smart
              phones or other electronic devices (<strong>“Devices”</strong>),
              and this Agreement shall apply with equal force and measure to
              your access and use of the Platform through such Devices. You are
              responsible for obtaining and updating the Device, software,
              operating system, carrier and network access necessary to properly
              access and use the Platform. Company does not guarantee that the
              Platform or any portions thereof 35789369v.1 will function on or
              in connection with any particular Device, software, operating
              system, carrier, or network. If you access or use the Platform
              through a particular Device, then you hereby acknowledge and agree
              that information about your use of the Platform through that
              Device or its carrier or network (such as, by way of example only,
              the identity of your Device, or your Device’s carrier or network)
              may be communicated to Company and/or certain third parties (such
              as, by way of example only, your Device’s carrier or network). All
              or any part of the voice, message and data fees, rates, charges
              and taxes of your Device’s carrier or network, or another third
              party, may apply to your access or use of the Platform. Company is
              not responsible for, and you further accept full responsibility
              for, all Device carrier and network fees, rates, charges and taxes
              which may apply, if any.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Ownership.</strong> The Platform
              and all elements and derivatives of the Platform (including,
              without limitation, all content, information, source codes, object
              codes, data, instructions, documentation, and expressions), as
              well as all copyrights, trademarks, trade secrets, and other
              intellectual properties of the foregoing, are owned, licensed, or
              permissibly used by Company. In no event shall you have or retain
              any rights, title, or interests in or to the foregoing other than
              those limited rights expressly granted to you under this
              Agreement. No rights or permissions granted to you under this
              Agreement are coupled with an interest. Nothing contained in this
              Agreement shall be construed as a waiver or limitation of
              Company’s or its licensors’ respective rights and remedies under
              applicable law.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">User Account.</strong>
            </p>
            <ol type="a" id="list-lower-alpha">
              <li>
                <p>
                  <span className="t-underline">Registration.</span> As
                  explained further herein, to secure the right to access and
                  use the registration-only pages or features of the Platform,
                  you may be required to register with and create a personal
                  user account with Company through the Platform (a{" "}
                  <strong>“User Account”</strong>), as well as reaffirm your
                  acceptance of and agreement to this Agreement and those
                  additional terms, conditions, and policies referenced herein,
                  as Company may require from time-to-time. As part of the
                  registration process, you may be required to satisfy certain
                  conditions precedent imposed by Company (including, for
                  example, providing additional information to Company and
                  entering into additional agreements with Company). Unless
                  otherwise permitted by Company in writing, you may only have
                  one non-transferable User Account.
                </p>
              </li>
              <li>
                <p>
                  <span className="t-underline">
                    User Account Activity and Information.
                  </span>{" "}
                  You are responsible for all activity that occurs under your
                  User Account and are prohibited from authorizing or allowing
                  any third party to access or use your User Account.
                  Accordingly, you should take all steps necessary to protect
                  and keep secret your User Account details and access
                  information (including your login name and password). You
                  should also maintain accurate, complete, and up-to-date
                  information in your User Account, because your failure to do
                  so may result in your inability to access, use, or receive all
                  or any part of the Platform and/or Company’s termination of
                  this Agreement. For the sake of security, you must immediately
                  notify Company if you suspect that a third party has gained
                  access to or is making any use of your User Account without
                  authorization. For the avoidance of doubt, Company has the
                  unencumbered right to access and use, and to allow its agents,
                  employees, representatives, contractors, and vendors to access
                  and use, the information in your User Account to facilitate
                  the exercise and performance of Company’s rights and
                  obligations under this Agreement (including, 35789369v.1
                  without limitation, the Services), the operation of the
                  Platform, and/or any other rights, obligations, operations,
                  products, and services related to the Platform, the Services,
                  your User Account, or the subject matter of this Agreement
                  (including, without limitation, communications).
                </p>
              </li>
              <li>
                <p>
                  <span className="t-underline">
                    Indemnification in Connection with User Account.
                  </span>{" "}
                  IF YOU FAIL TO COMPLY WITH ANY TERMS OR CONDITIONS OF SECTION
                  5(B) ABOVE (WHETHER INTENTIONALLY OR UNINTENTIONALLY), THEN
                  YOU ACCEPT FULL RESPONSIBILITY FOR THE CONSEQUENCES THEREOF
                  (INCLUDING, WITHOUT LIMITATION, ANY UNAUTHORIZED CHANGES TO
                  YOUR USER ACCOUNT INFORMATION AND SETTINGS, AND ANY
                  UNAUTHORIZED ACCESS OR USE OF YOUR USER ACCOUNT); AND YOU
                  AGREE TO INDEMNIFY, RELEASE, AND HOLD HARMLESS COMPANY,
                  COMPANY’S SUBSIDIARIES AND OTHER AFFILIATES, AND THEIR
                  RESPECTIVE OFFICERS, DIRECTORS, MANAGERS, OWNERS, PARTNERS,
                  AGENTS, EMPLOYEES, REPRESENTATIVES, TRUSTEES, ASSIGNS,
                  TRANSFEREES, CONTRACTORS, VENDORS, AND LICENSEES FROM AND
                  AGAINST ANY AND ALL LIABILITIES, CLAIMS, SUITS, DEMANDS,
                  ACTIONS, JUDGMENTS, LOSSES, DAMAGES, FINES, PENALTIES, AND
                  EXPENSES (INCLUDING COSTS AND REASONABLE OUTSIDE ATTORNEY
                  FEES) INCURRED BY OR ASSERTED AGAINST ANY SUCH INDEMNITEES,
                  ARISING OUT OF OR IN CONNECTION WITH YOUR FAILURE TO COMPLY
                  WITH SUCH TERMS OR CONDITIONS.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                Rights, Permissions, and Consents.
              </strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">
                      License of the Platform.
                    </span>{" "}
                    Subject to the terms and conditions of this Agreement,
                    Company grants you a limited, non-exclusive, personal,
                    freely-revocable, non-transferable, and nonsub-licensable
                    license to access and view the various publicly displayed
                    pages of the Platform, and to view the information and
                    content found thereon. You may only access the Platform and
                    the Services for the permitted purposes set forth herein.
                    Your unauthorized use of the Platform, or any breach by you
                    of this Agreement, automatically terminates this license.{" "}
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      License of User Materials.
                    </span>{" "}
                    All names, information, statements, communications, and any
                    other content that you submit to or publish on, through, or
                    in relation to the Platform, including those which you
                    submit to or publish on any online social media account that
                    you own and link or otherwise associate with the Platform,
                    if any and as applicable, is hereinafter defined as the
                    “User Materials.” You hereby grant Company an irrevocable,
                    non-exclusive, royalty-free, fully-paid, transferable,
                    sub-licensable, perpetual, and universe-wide license for
                    Company to host, store, reproduce, transmit, distribute,
                    sell, resell, license, sublicense, market, modify, adapt,
                    create derivative works, communicate, publish, syndicate,
                    publicly perform, publicly display, archive, and otherwise
                    use and exploit all or any part of such User Materials and
                    any elements and derivatives thereof in any language,
                    manner, medium, or form, whether now known or hereinafter
                    devised, as Company sees fit in its sole discretion. For the
                    avoidance of doubt, the foregoing is not intended to
                    conflict with any provision of the Privacy Policy.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Reservation of Rights.</span>{" "}
                    Nothing in this Agreement restricts or limits Company’s
                    rights, title, or interests in or to the Platform, the
                    Services, the User Materials, or any elements or derivatives
                    of the foregoing.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Warnings; Disclaimers.</span>{" "}
                    PLEASE NOTE THAT THE USER MATERIALS MIGHT BECOME THE SUBJECT
                    OF PUBLIC DISCLOSURE.THUS, COMPANY IS NOT RESPONSIBLE FOR,
                    AND EXPRESSLY DISCLAIMS ANY LIABILITY ARISING FROM OR IN
                    CONNECTION WITH, ITS USE OF ANY USER MATERIALS IN ACCORDANCE
                    WITH THE TERMS AND CONDITIONS OF THIS AGREEMENT. For the
                    avoidance of doubt, the foregoing is not intended to
                    conflict with any provision of the Privacy Policy.
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                Suspension or Termination of Service; Disclaimer.
              </strong>{" "}
              Company has the right, but not the obligation, to suspend or
              terminate the function or existence of all or any part of the
              Platform. COMPANY SHALL NOT BE LIABLE TO YOU OR ANY THIRD PARTY
              FOR ANY LOSS OR DAMAGE THAT IS CAUSED BY OR ARISES FROM OR IN
              CONNECTION WITH ANY SUCH SUSPENSION OR TERMINATION (INCLUDING,
              WITHOUT LIMITATION AND BY WAY OF EXAMPLE ONLY, REFUNDS, LOST
              PROFITS, LOST OPPORTUNITIES, MONETARY DAMAGES, DISRUPTION IN OR
              LOSS OF SERVICE, OR LOSS OF CONTENT).
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Products and Services.</strong>{" "}
              Company or its affiliates or licensees might offer, sell, license,
              or otherwise make available various products or services (which
              may include Company’s own products and services or the products
              and services of third parties) on, through, or in relation to the
              Platform, some of which might only be made available to you upon
              completion and submission of an online form or other instructions
              provided to you by Company or which may be available exclusively
              online or in limited quantities on or through the Platform.
              Company has the right to refuse its products and services to you
              or to any geographic region or jurisdiction, including if it
              suspects that you are in any way involved in fraudulent or illegal
              activity, and may contact your payment method issuer, law
              enforcement or others and share information relating to your
              payments, as applicable, if Company believes doing so will prevent
              a violation of the law or financial loss. Prices for, and
              descriptions of, any products or services offered on or through
              the Platform are subject to change without notice and in the sole
              discretion of Company. Company reserves the right to discontinue
              any product or service at any time.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Payments.</strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">
                      Third-Party Payment Processing Vendor.
                    </span>{" "}
                    All credit card, debit card, and other monetary transactions
                    conducted on or through the Platform occur through an online
                    payment processing application that may be provided by a
                    third-party vendor. COMPANY’S RELATIONSHIP WITH ANY
                    THIRD-PARTY PAYMENT PROCESSING VENDOR IS MERELY CONTRACTUAL
                    IN NATURE, AND SUCH THIRD-PARTY PAYMENT PROCESSING VENDOR IS
                    IN NO WAY SUBJECT TO COMPANY’S DIRECTION OR CONTROL. THUS,
                    SUCH RELATIONSHIP IS NOT, AND SHOULD NOT BE CONSTRUED AS,
                    ONE OF FIDUCIARIES, FRANCHISORS-FRANCHISEES,
                    AGENTS-PRINCIPALS, EMPLOYERS-EMPLOYEES, PARTNERS, JOINT
                    VENTURERS, CONTRACTORS, OR THE LIKE.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Payment Authorization.</span>{" "}
                    IF YOU PROVIDE COMPANY WITH YOUR PAYMENT INFORMATION, THEN
                    YOU AUTHORIZE COMPANY TO DO THE FOLLOWING AS COMPANY DEEMS
                    NECESSARY, ALTHOUGH COMPANY HAS NO OBLIGATION TO DO SO: (A)
                    SHARE YOUR PAYMENT INFORMATION WITH THE THIRD-PARTY PAYMENT
                    PROCESSING VENDOR(S); AND (B) OBTAIN 35789369v.1 YOUR
                    UPDATED PAYMENT INFORMATION FROM YOUR PAYMENT ISSUER AND/OR
                    THE THIRDPARTY PAYMENT PROCESSING VENDOR(S).
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Payment Obligations.</span>{" "}
                    You agree that you are responsible for all amounts that
                    accrue under your account(s) with Company, the third-party
                    payment processing vendor(s), and/or other third parties as
                    a result of your use or access of the Platform or Services.
                    You also agree to be responsible for all payments, fines,
                    penalties and other liabilities incurred by any such person
                    or entity that arises out of or relates to payments that you
                    authorize or accept on or through the Platform, including,
                    without limitation, all fees, penalties, taxes and duties;
                    and to be responsible for all expenses (including costs and
                    reasonable outside attorney fees) and interest incurred by
                    any such person or entity to collect any overdue amounts.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Waiver of Claims; Unauthorized Payments.
                    </span>{" "}
                    TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AGREE TO WAIVE
                    ALL CLAIMS AGAINST COMPANY RELATED TO ANY UNAUTHORIZED
                    PAYMENTS MADE ON OR THROUGH YOUR ACCOUNT(S) WITH COMPANY,
                    THE THIRD-PARTY PAYMENT PROCESSING VENDOR(S), AND/OR ANY
                    OTHER THIRD PARTIES AS A RESULT OF YOUR USE OR ACCESS OF THE
                    PLATFORM OR SERVICES, REGARDLESS OF WHETHER THE PAYMENTS ARE
                    AUTHORIZED OR UNAUTHORIZED. However, you may submit a claim
                    of the unauthorized payment to Company and Company will
                    undertake a reasonable investigation as it sees fit under
                    the circumstances of and, if Company deems appropriate,
                    assist in correcting the alleged unauthorized payment,
                    provided that such claim (an{" "}
                    <strong>“Unauthorized Payment Claim”</strong>) is received
                    by Company within 15 days of the subject charge or payment.
                    Each Unauthorized Payment Claim must be submitted to any one
                    of the following:
                    <p className="indent">
                      <p>
                        <span>By mail:</span>
                        <span className="indent">
                          Atlas Energy Solutions, Inc., 5918 W Courtyard Dr
                          Suite 500, Austin, TX 78730, Attention: VP Technology
                          with a subject line of “Claim Concerning Unauthorized
                          Payment.”
                        </span>
                      </p>
                      <p>
                        <span>By e-mail:</span>
                        <span className="indent">
                          <span className="link-w-bg">
                            <a href="mailto:privacy@atlas.energy">
                              privacy@atlas.energy,
                            </a>
                          </span>{" "}
                          with a subject line of “Claim Concerning Unauthorized
                          Payment.”
                        </span>
                      </p>
                    </p>
                    <p>
                      For each Unauthorized Payment Claim, please state “Claim
                      Concerning Unauthorized Payment” in the e-mail or letter
                      subject line, and clearly state the following in the body:
                    </p>
                    <ol type="i">
                      <li>
                        <p>
                          the date and approximate time of the subject
                          transaction;
                        </p>
                      </li>
                      <li>
                        <p>
                          the services tendered or to be tendered under the
                          subject transaction;
                        </p>
                      </li>
                      <li>
                        <p>
                          the total monetary amount of the subject transaction;
                        </p>
                      </li>
                      <li>
                        <p>
                          whether the subject transaction was made on or though
                          the Platform;
                        </p>
                      </li>
                      <li>
                        <p>
                          the parties to the subject transaction, including the
                          buyer and seller;
                        </p>
                      </li>
                      <li>
                        <p>
                          a detailed explanation for why you believe the charge
                          or payment made under the subject transaction is
                          unauthorized;
                        </p>
                      </li>
                      <li>
                        <p>
                          the monetary amount of the subject transaction you
                          believe is subject to a refund;
                        </p>
                      </li>
                      <li>
                        <p>
                          your name, street address, city, state, zip code and
                          e-mail address; and
                        </p>
                      </li>
                      <li>
                        <p>
                          whether you prefer to receive a response to your
                          request by mail or e-mail.
                        </p>
                      </li>
                    </ol>
                    <p>
                      IF YOU SEND AN UNAUTHORIZED PAYMENT CLAIM BY MAIL, THEN
                      PLEASE DO SO BY U.S. CERTIFIED MAIL, RETURN RECEIPT
                      REQUESTED TO ALLOW FOR CONFIRMATION OF MAILING, DELIVERY,
                      AND TRACKING. COMPANY WILL NOT ACCEPT AN UNAUTHORIZED
                      PAYMENT CLAIM VIA TELEPHONE OR FACSIMILE. COMPANY IS NOT
                      RESPONSIBLE FOR ANY UNAUTHORIZED PAYMENT CLAIM THAT IS
                      INCOMPLETE, INCORRECTLY LABELED, INCORRECTLY SENT OR
                      UNTIMELY.
                    </p>
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Accurate Payment Information.
                    </span>{" "}
                    You represent and warrant to Company that any payment
                    information you provide on or through the Platform is
                    current, complete and accurate, and that you will promptly
                    notify Company if your payment information has changed (such
                    as a change in address or expiration date), if your payment
                    method has been cancelled, or if you become aware of a
                    breach of security.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">No Refunds.</span> All sales
                    and payments made on, through or regarding the Platform
                    and/or the Services are final, irrevocable, and not subject
                    to or eligible for a refund.
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                Electronic Communications.
              </strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">Express Consent.</span> YOU
                    HEREBY EXPRESSLY CONSENT TO COMPANY SENDING OR OTHERWISE
                    COMMUNICATING WITH YOU FOR ANY PURPOSE (INCLUDING, WITHOUT
                    LIMITATION, FOR ADVERTISING, TELEMARKETING, OR OTHER
                    MARKETING OR PROMOTIONAL PURPOSES, OR FOR SENDING OR
                    NOTIFYING YOU ABOUT SPECIAL OFFERS, UPDATES, NEWSLETTERS OR
                    OTHER INFORMATIONAL PURPOSES) VIA ANY ELECTRONIC MEANS OR
                    FORMS AS COMPANY DEEMS APPROPRIATE IN ITS SOLE DISCRETION,
                    WHETHER THROUGH THE PLATFORM, THROUGH YOUR USER ACCOUNT, BY
                    PERSONAL COMMUNICATION, BY E-MAIL, BY AUTOMATIC TELEPHONE
                    DIALING SYSTEM, BY TELEPHONE, BY ARTIFICIAL OR PRERECORDED
                    VOICE, BY ONLINE SOCIAL MEDIA, BY TEXT MESSAGE (E.G., SHORT
                    MESSAGE SERVICE A/K/A SMS, AND MULTIMEDIA MESSAGING SERVICE
                    A/K/A MMS) OR BY OTHER ELECTRONIC MEDIA MEANS OR FORMS. BY
                    GIVING SUCH CONSENT, YOU AGREE THAT NO SUCH COMMUNICATION
                    SHALL VIOLATE THE CAN-SPAM ACT, THE TELEPHONE CONSUMER
                    PROTECTION ACT, OR ANY OTHER APPLICABLE LAWS, RULES, OR
                    REGULATIONS. VOICE, MESSAGE, AND DATA FEES, RATES, CHARGES,
                    AND TAXES MAY APPLY TO YOU, AND YOU ARE RESPONSIBLE FOR
                    PAYMENT OF THE SAME. YOU ARE NOT REQUIRED TO GRANT THE
                    FOREGOING CONSENT AS A CONDITION FOR PURCHASE OR LICENSE OF
                    ANY COMPANY PRODUCTS OR SERVICES.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">E-mail Opt-Out.</span> You may
                    opt-out of receiving any electronic messages from Company as
                    described in Section 10(a) above at any time by any
                    reasonable means, including, without limitation and by way
                    of example, by sending an e-mail to privacy@atlas.energy
                    with a subject line of “Opt-Out of Electronic
                    Communications.” You acknowledge that opting out of
                    receiving any such communications may impact your receipt,
                    the success, and/or the 35789369v.1 performance of all or
                    any part of the Platform and/or your ability to receive
                    certain messages or notifications from Company
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Prohibited Activities.</strong>{" "}
              You shall not engage in any of the following activities at any
              time with respect to the Platform: (a) the impersonation of any
              person or entity; (b) any act that infringes or otherwise violates
              the intellectual property, privacy, or publicity rights of any
              person or entity (including, without limitation, the copyrights,
              trademarks, patents, and trade secrets held by Company or its
              licensors with respect to the Platform); (c) the reproduction of
              the Platform or any communications, information or content found
              thereon or therein, in whole or in part, or the creation of any
              derivative works of the foregoing (unless expressly authorized by
              Company herein); (d) the publication of any content that is
              objectionable or illegal (including, without limitation, content
              that is indecent, obscene, infringing, an invasion of privacy,
              defamatory, disparaging, false, deceptive, misleading, untruthful,
              fraudulent, threatening, or abusive); (e) the publication of a
              person’s or entity’s personal information or private facts without
              his/her/its prior written consent; (f) the publication of any
              machine, computer, or randomly generated content; (g) supplying or
              publishing any information or statements on, through, or in
              relation to the Platform that is false, misleading, deceptive, or
              incorrect; (h) any act intended or designed to drive traffic to or
              boost the search rankings of third-party websites, networks,
              platforms, servers, or applications; (i) the systematic retrieval
              or copying of any information or content found on, through, or in
              relation to the Platform or its servers to directly or indirectly
              create or compile, in whole or in part, a collection, compilation,
              database, or directory; (j) the use of any software, program,
              process, device, application, or routine (including, by way of
              example only, robots, scrapers, spiders, viruses, spyware, and
              malware) to monitor, copy, disrupt, damage, injure, interfere with
              or impermissibly access, in whole or in part, the Platform or its
              servers; (k) any act that involves or concerns decrypting,
              security bypassing or circumventing, hacking, data mining, data
              scraping, data harvesting, reverse engineering, decompiling,
              disassembling, attempting to derive source code, modifying,
              copying or the like on, through, or in relation to the Platform or
              its servers; (l) any act that overloads, unreasonably disrupts, or
              unreasonably interferes with the infrastructure of the Platform or
              its servers; (m) any act that gains or attempts to gain
              unauthorized access to computer systems, networks, information, or
              materials on, through, or in relation to the Platform or its
              servers; or (n) any other act that Company becomes aware of and
              believes in good faith is improper, illegal, or harmful to the
              Platform, its servers, or any person, entity, or property.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                Links to Other Platforms, Apps, Networks, and Servers.
              </strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">Linked Technologies.</span>{" "}
                    The Platform, or any communications sent on, through, or as
                    a function of the Platform, may contain links to third-party
                    websites, networks, platforms, servers, or applications,
                    and, similarly, third-party websites, networks, platforms,
                    servers, applications, or communications may contain links
                    to the Platform (collectively,
                    <strong>“Linked Technologies”</strong>). The Linked
                    Technologies are not under the control of Company or the
                    Platform, and any such communications contain the outgoing
                    links as a convenience to you, if for any purpose.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Disclaimer About Linked Technologies
                    </span>{" "}
                    COMPANY IS NOT RESPONSIBLE FOR ANY INFORMATION, CONTENT,
                    GOODS, SERVICES, PROMOTIONS, ADVERTISEMENTS, PROGRAMS,
                    35789369v.1 CODES, OR OTHER ITEMS WHICH MAY BE FOUND ON OR
                    EXCLUDED FROM THE LINKED TECHNOLOGIES (INCLUDING, WITHOUT
                    LIMITATION AND BY WAY OF EXAMPLE ONLY, MALICIOUS SOFTWARE,
                    SPYWARE PROGRAMS, INACCURATE INFORMATION, AND ILLEGAL
                    CONTENT). COMPANY DOES NOT MAKE, NOR HAS COMPANY MADE, ANY
                    REPRESENTATIONS OR WARRANTIES (WHETHER EXPRESS, IMPLIED, OR
                    OTHERWISE) CONCERNING THE TERMS OF USE OR SERVICE, PRIVACY
                    POLICIES, AGREEMENTS, INFORMATION, CONTENT, GOODS, SERVICES,
                    PROMOTIONS, ADVERTISEMENTS, PROGRAMS, CODES, OR OTHER ITEMS
                    WHICH MAY BE FOUND ON OR EXCLUDED FROM THE LINKED
                    TECHNOLOGIES; NOR SHALL THE FACT THAT THE PLATFORM MAY LINK
                    TO OR FROM ANY LINKED TECHNOLOGIES CONSTITUTE AN AFFILIATION
                    WITH, ASSOCIATION WITH, OR ENDORSEMENT OF SUCH LINKED
                    TECHNOLOGIES OR ANY INFORMATION, CONTENT, GOODS, SERVICES,
                    PROMOTIONS, ADVERTISEMENTS, PROGRAMS, CODES, OR OTHER ITEMS
                    WHICH MAY BE FOUND ON OR EXCLUDED FROM SUCH LINKED
                    TECHNOLOGIES. IF YOU DECIDE TO ACCESS ANY LINKED
                    TECHNOLOGIES, THEN YOU DO SO AT YOUR OWN RISK
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Take Down.</strong> Company
              reserves the right, but not the obligation, to take down or
              otherwise exclude from the Platform, without notice or recourse,
              any communications, statements, names, photographs, information,
              and/or content made or submitted by you or others on or through
              the Platform that Company believes, at any time and in its sole
              discretion, to be infringing or otherwise in violation of the
              proprietary rights, the right of privacy, or the right of
              publicity of any person or entity; defamatory, disparaging, or
              embarrassing of or towards any person or entity; profane, indecent
              or obscene; derogatory in terms of race, nationality, religion,
              gender, gender identification, sexual orientation or otherwise;
              threatening; abusive; false, misleading or deceptive; or otherwise
              illegal or something that Company considers unsuitable for the
              Platform or its users.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                User Representations, Warranties, and Covenants.{" "}
              </strong>
              You represent, warrant, and covenant to Company that: (a) you are
              a natural person and of 18 years of age or older, or otherwise the
              age of majority in your jurisdiction; (b) you have read and
              understand this Agreement in its entirety; (c) you have the full
              right and authority to enter into and abide by the terms and
              conditions of this Agreement; (d) you understand and acknowledge
              that, by accepting this Agreement, you are giving up certain legal
              rights and remedies; (e) you voluntarily accept and agree to, and
              will fully comply with, the terms and conditions of this
              Agreement; (f) you will not violate any applicable international,
              federal, state, or local laws which may concern the Platform, the
              Platform’s servers or any information, communications, or content
              found on or through them; (g) you are the exclusive owner of all
              rights, title, and interests in and to the User Materials
              (including, without limitation, all copyrights, trademarks,
              patents, trade secrets, rights of publicity, and rights of
              privacy) and/or, if applicable, have secured all necessary rights
              and permissions from all subjects depicted in, and all persons and
              entities who contributed to, the User Materials to allow for your
              performance and grant of rights hereunder; (h) the User Materials
              are wholly original to you; (i) the User Materials do not and will
              not infringe upon or otherwise violate the proprietary, publicity,
              or privacy rights of any person or entity; (j) the User Materials
              do not and will not defame, disparage, embarrass, or disclose
              confidential, private, or personal information about or belonging
              to any person or entity; (k) nothing contained in the User
              Materials is or will be, or contains or will contain, links to
              material that is profane, indecent, obscene, threatening, abusive,
              illegal, false, misleading or any form of spam, malware, virus,
              bug, bot, spyware, or other malicious or tracking technology; (l)
              35789369v.1 Company is not required to seek the permission of or
              compensate any third party to exercise any of the rights granted
              by you under this Agreement; (m) no obligation, disability,
              agreement, or adverse claim exists that may restrict your
              performance or grant of rights hereunder; (n) all information you
              provide to Company in connection with your access or use of the
              Platform and/or the Services is truthful and accurate; and (o) you
              are not listed on any United States government list of prohibited
              or restricted parties.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                Disclaimers and Limitations.
              </strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">General Disclaimer.</span>{" "}
                    YOUR ACCESS OR USE OF THE PLATFORM OR ANY PRODUCTS OR
                    SERVICES MADE AVAILABLE TO YOU ON, THROUGH, OR IN RELATION
                    TO THE PLATFORM (INCLUDING, WITHOUT LIMITATION, THE
                    SERVICES) IN ANY WAY IS DONE AT YOUR OWN RISK. THE PLATFORM,
                    THOSE PRODUCTS AND SERVICES (INCLUDING, WITHOUT LIMITATION,
                    THE SERVICES), THE SUCCESS OR PERFORMANCE OF THE PLATFORM OR
                    THOSE PRODUCTS AND SERVICES (INCLUDING, WITHOUT LIMITATION,
                    THE SERVICES) AND ALL INFORMATION, COMMUNICATIONS, CONTENT
                    AND FEATURES OFFERED, MARKETED, SOLD, PROVIDED, LICENSED OR
                    MADE AVAILABLE ON, THROUGH, OR IN RELATION TO THE PLATFORM
                    OR THOSE PRODUCTS AND SERVICES (INCLUDING, WITHOUT
                    LIMITATION, THE SERVICES) ARE PROVIDED TO YOU ON AN “AS IS,”
                    “WHERE IS,” “AS AVAILABLE,” AND “WITH ALL FAULTS” BASIS AND
                    WITHOUT ANY WARRANTY. COMPANY DOES NOT MAKE, NOR HAS COMPANY
                    MADE, ANY REPRESENTATIONS OR WARRANTIES OF ANY KIND OR
                    NATURE (WHETHER DIRECT OR INDIRECT, ORAL OR WRITTEN, OR
                    EXPRESS OR IMPLIED) TO YOU WITH RESPECT TO THE PLATFORM, ANY
                    OF THOSE PRODUCTS AND SERVICES (INCLUDING, WITHOUT
                    LIMITATION, THE SERVICES), ANY SUCH INFORMATION,
                    COMMUNICATIONS, CONTENT, AND FEATURES OR THEIR SUCCESS,
                    PERFORMANCE, FUNCTIONALITY, QUALITY, COMPLETENESS, ACCURACY,
                    RELIABILITY, MARKETABILITY, OR SAFETY. COMPANY EXPRESSLY
                    DISCLAIMS ANY AND ALL EXPRESS WARRANTIES, IMPLIED WARRANTIES
                    (INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF
                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, GOOD
                    FAITH AND FAIR DEALING, TITLE, NON-INFRINGEMENT,
                    PERFORMANCE, FUNCTIONALITY, QUALITY, COMPLETENESS, ACCURACY,
                    RELIABILITY, AND SAFETY) AND WARRANTIES ARISING FROM
                    CONDUCT, COURSE OF DEALING, CUSTOM AND USAGE IN TRADE WITH
                    RESPECT TO THE PLATFORM, THOSE PRODUCTS AND SERVICES
                    (INCLUDING, WITHOUT LIMITATION, THE SERVICES), ANY SUCH
                    INFORMATION, COMMUNICATIONS, CONTENT OR FEATURES AND THEIR
                    SUCCESS, PERFORMANCE, FUNCTIONALITY, QUALITY, COMPLETENESS,
                    ACCURACY, RELIABILITY, MARKETABILITY, AND SAFETY. COMPANY
                    DOES NOT MAKE, NOR HAS COMPANY MADE, ANY AFFIRMATION OF
                    FACT, PROMISE OR WARRANTY (WHETHER EXPRESS, IMPLIED, OR
                    OTHERWISE) RELATING TO THE PLATFORM, THOSE PRODUCTS AND
                    SERVICES (INCLUDING, WITHOUT LIMITATION, THE SERVICES), OR
                    ANY SUCH INFORMATION, COMMUNICATIONS, CONTENT, OR FEATURES
                    OR ITS SUCCESS, PERFORMANCE, FUNCTIONALITY, QUALITY,
                    COMPLETENESS, ACCURACY, RELIABILITY, MARKETABILITY, OR
                    SAFETY THAT EXTENDS BEYOND THE FACE OF THIS AGREEMENT OR
                    THAT HAS BECOME ANY BASIS OF ANY BARGAIN.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Disclaimer About System Delays.
                    </span>{" "}
                    YOU UNDERSTAND AND ACKNOWLEDGE THAT THE PLATFORM MAY BE
                    SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS INHERENT
                    IN THE USE OF THIRD-PARTY COMMUNICATION NETWORKS AND
                    FACILITIES THAT ARE OUTSIDE OF COMPANY’S CONTROL.
                    ACCORDINGLY, COMPANY SHALL NOT BE RESPONSIBLE FOR, AND
                    35789369v.1 EXPRESSLY DISCLAIMS, ANY DELAYS, FAILURES,
                    LOSSES, INJURIES, LIABILITIES, OR DAMAGES ASSOCIATED WITH
                    THE PLATFORM WHICH RESULT FROM ANY SYSTEM DELAYS, DOWNTIMES,
                    INTERRUPTIONS, OR OTHER FAILURES OF, OR PROBLEMS WITH, THE
                    PLATFORM WHICH ARE OUTSIDE OF COMPANY’S CONTROL (
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Disclaimer About Certain Information, Communications and
                      Content.
                    </span>{" "}
                    ANY OPINIONS, ADVICE, REVIEWS, STATEMENTS, OFFERS, OR OTHER
                    INFORMATION, COMMUNICATIONS OR CONTENT FOUND ON, THROUGH OR
                    IN RELATION TO COMPANY, THE PLATFORM, THE SERVICES, OR ANY
                    THIRD-PARTY PROVIDERS (INCLUDING, WITHOUT LIMITATION, ONLINE
                    FORUMS, OTHER WEBSITES, ADVERTISEMENTS, AND SOCIAL MEDIA
                    PAGES) ARE THOSE OF THEIR RESPECTIVE AUTHORS, AND NOT
                    NECESSARILY THOSE OF COMPANY; THUS, THEY SHOULD NOT
                    NECESSARILY BE RELIED UPON. SUCH AUTHORS ARE SOLELY
                    RESPONSIBLE FOR THE ACCURACY OF SUCH INFORMATION,
                    COMMUNICATIONS, OR CONTENT. COMPANY DOES NOT GUARANTEE,
                    ADOPT, OR ENDORSE THE ACCURACY, COMPLETENESS, RELIABILITY,
                    OR USEFULNESS OF ANY SUCH INFORMATION, COMMUNICATIONS, OR
                    CONTENT, EVEN IF COMPANY IS THE AUTHOR. COMPANY IS NOT
                    RESPONSIBLE FOR THE ACCURACY, COMPLETENESS, RELIABILITY OR
                    USEFULNESS OF ANY SUCH INFORMATION, COMMUNICATIONS OR
                    CONTENT. UNDER NO CIRCUMSTANCES SHALL COMPANY BE LIABLE TO
                    YOU OR ANY THIRD PARTIES FOR ANY LOSS OR DAMAGE CAUSED BY OR
                    ARISING FROM OR IN CONNECTION WITH YOUR RELIANCE ON ANY SUCH
                    INFORMATION, COMMUNICATIONS, OR CONTENT.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Limitation of Liability.
                    </span>{" "}
                    IN NO EVENT SHALL COMPANY, ANY OF COMPANY’S SUBSIDIARIES OR
                    OTHER AFFILIATES, OR ANY OF THEIR RESPECTIVE OFFICERS,
                    DIRECTORS, MANAGERS, OWNERS, PARTNERS, AGENTS, EMPLOYEES,
                    REPRESENTATIVES, TRUSTEES, ASSIGNS, TRANSFEREES,
                    CONTRACTORS, VENDORS, OR LICENSEES BE HELD LIABLE TO (OR BE
                    OBLIGATED TO INDEMNIFY) YOU OR ANY THIRD PARTY FOR ANY
                    DIRECT, INDIRECT, PUNITIVE, OR SPECIAL DAMAGES (INCLUDING,
                    WITHOUT LIMITATION, LEGAL COSTS, ATTORNEY FEES, LOST
                    PROFITS, REPLACEMENT COSTS, OR REPAIR COSTS) CAUSED BY OR
                    ARISING FROM OR IN CONNECTION WITH: (I) YOUR ACCESS OR USE
                    OF THE PLATFORM, OR YOUR INABILITY TO ACCESS OR USE THE
                    PLATFORM OR THE SERVICES; (II) ANY PRODUCTS OR SERVICES
                    (INCLUDING, WITHOUT LIMITATION, THE SERVICES) MADE AVAILABLE
                    ON, THROUGH, OR IN RELATION TO THE PLATFORM;(III) ANY
                    STATEMENTS, CONTENT, OR CONDUCT OF ANY THIRD PARTY ON,
                    THROUGH OR IN RELATION TO THE PLATFORM OR ANY SUCH PRODUCTS
                    OR SERVICES (INCLUDING, WITHOUT LIMITATION, THE SERVICES);
                    (IV) ANY UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR
                    PERSONAL INFORMATION; (V) ANY HACKING, DENIAL OF SERVICE
                    ATTACKS, DATA SECURITY BREACHES OR OTHER THIRD-PARTY CONDUCT
                    THAT MAY LEAD TO A COMPROMISE OF YOUR PERSONAL INFORMATION
                    OR DAMAGE TO YOUR DEVICE(S), SOFTWARE, OPERATING SYSTEM(S),
                    FILE(S), CARRIER(S) OR NETWORK(S); (VI) ANY TRANSMISSION,
                    DOWNLOAD OR INFECTION OF ANY SOFTWARE, SYSTEM, PROGRAM,
                    FILE, PROCESS, DEVICE, APPLICATION OR ROUTINE (INCLUDING,
                    WITHOUT LIMITATION AND BY WAY OF EXAMPLE ONLY, ROBOTS,
                    SCRAPERS, SPIDERS, VIRUSES, SPYWARE AND MALWARE) THAT MAY
                    LEAD TO A COMPROMISE OF YOUR PERSONAL INFORMATION OR DAMAGE
                    TO YOUR DEVICE(S), SOFTWARE, OPERATING SYSTEM(S), FILE(S),
                    CARRIER(S), OR NETWORK(S); (VII) THE FACT THAT YOU HAVE
                    RELIED ON ANY INFORMATION, CONTENT OR COMMUNICATIONS
                    PUBLISHED ON, THROUGH OR IN RELATION TO THE PLATFORM OR ANY
                    SUCH PRODUCTS OR 35789369v.1 SERVICES (INCLUDING, WITHOUT
                    LIMITATION, THE SERVICES); OR (VIII) ANY ACTS, ERRORS OR
                    OMISSIONS OF ANY THIRD-PARTY PROVIDERS. IF YOU ARE
                    DISSATISFIED WITH THE PLATFORM OR ANY PRODUCTS OR SERVICES
                    OFFERED (INCLUDING, WITHOUT LIMITATION, THE SERVICES), SOLD,
                    LICENSED, OR MADE AVAILABLE ON, THROUGH, OR IN RELATION TO
                    THE PLATFORM, THEN YOUR SOLE AND EXCLUSIVE REMEDY IS TO
                    DISCONTINUE YOUR ACCESS AND USE OF THE PLATFORM AND SUCH
                    PRODUCTS AND SERVICES (INCLUDING, WITHOUT LIMITATION, THE
                    SERVICES).
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Limitation of Remedies.</span>{" "}
                    IF COMPANY BREACHES OR OTHERWISE VIOLATES THIS AGREEMENT,
                    THEN IN NO EVENT SHALL YOU BE ENTITLED TO RECOVER ANY
                    SPECIAL, INCIDENTAL, CONSEQUENTIAL, SPECULATIVE, EXEMPLARY,
                    OR PUNITIVE DAMAGES ARISING OUT OF OR IN RELATION TO SUCH
                    BREACH OR OTHER VIOLATION, EVEN IF COMPANY HAS BEEN NOTIFIED
                    OF THE POSSIBILITY OF SUCH DAMAGES.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">No Injunctive Relief.</span>{" "}
                    IF COMPANY BREACHES OR OTHERWISE VIOLATES THIS AGREEMENT,
                    THEN YOU SHALL NOT BE ENTITLED TO SEEK OR OBTAIN, AND YOU DO
                    HEREBY WAIVE, ANY TYPE OF INJUNCTIVE RELIEF AGAINST THE
                    PLATFORM AND/OR ANY PRODUCTS OR SERVICES MADE AVAILABLE ON,
                    THROUGH, OR IN RELATION TO THE PLATFORM (INCLUDING, WITHOUT
                    LIMITATION, THE SERVICES) AS A RESULT OF SUCH BREACH OR
                    OTHER VIOLATION. FOR THE AVOIDANCE OF DOUBT, THE FOREGOING
                    LIMITATION ON INJUNCTIVE RELIEF DOES NOT LIMIT YOUR ABILITY
                    TO SEEK OR RECOVER ANY MONETARY REMEDIES AUTHORIZED BY LAW
                    IN THE EVENT OF ANY SUCH BREACH OR OTHER VIOLATION (EXCEPT
                    FOR THOSE WHICH ARE OTHERWISE EXPRESSLY PRECLUDED BY THIS
                    AGREEMENT); PROVIDED, THAT ANY SUCH NONPRECLUDED CAUSE OF
                    ACTION OR CLAIM IN CONNECTION WITH SUCH MONETARY REMEDIES
                    MUST BE COMMENCED WITHIN ONE YEAR AFTER THE CAUSE OF ACTION
                    OR CLAIM ACCRUES, OR ELSE SUCH CAUSE OF ACTION OR CLAIM IS
                    PERMANENTLY BARRED.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Consumer Protections.</span>{" "}
                    The disclaimers and limitations set forth in this Section 15
                    are not intended to limit liability or alter your rights as
                    a consumer that cannot be limited or altered under
                    applicable law.
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                General Release of Claims.{" "}
              </strong>
              YOU HEREBY RELEASE AND HOLD HARMLESS COMPANY, COMPANY’S
              SUBSIDIARIES AND OTHER AFFILIATES, AND THEIR RESPECTIVE OFFICERS,
              DIRECTORS, MANAGERS, OWNERS, PARTNERS, AGENTS, EMPLOYEES,
              REPRESENTATIVES, TRUSTEES, ASSIGNS, TRANSFEREES, CONTRACTORS,
              VENDORS, AND LICENSEES FROM AND AGAINST ALL CLAIMS THAT YOU HAVE
              OR MAY HAVE AGAINST THEM FOR INFRINGEMENT, VIOLATION OF THE RIGHTS
              OF PRIVACY OR PUBLICITY, DEFAMATION, DISPARAGEMENT, UNPAID
              BENEFITS, UNPAID WAGES, OVERTIME, DISCRIMINATION, PERSONAL INJURY,
              PROPERTY DAMAGE, NEGLIGENCE, AND/OR ANY OTHER LEGAL THEORY ARISING
              FROM OR IN CONNECTION WITH THE PLATFORM, THE PRODUCTS OR SERVICES
              MADE AVAILABLE ON, THROUGH, OR IN RELATION TO THE PLATFORM
              (INCLUDING, WITHOUT LIMITATION, THE SERVICES), AND/OR THE RIGHTS
              AND PRIVILEGES GRANTED OR CONVEYED BY YOU UNDER THIS AGREEMENT
              (INCLUDING, WITHOUT LIMITATION, THOSE RIGHTS AND PRIVILEGES
              RELATING TO THE USER MATERIALS AND/OR ANY ELEMENTS, DERIVATIVES,
              OR MARKETING OF THE FOREGOING). FURTHER, YOU WAIVE YOUR RIGHT TO,
              AND IN NO EVENT SHALL YOU SEEK TO, (A) ENJOIN COMPANY, ANY OF
              COMPANY’S OFFICERS, DIRECTORS, MEMBERS, MANAGERS, OWNERS,
              PARTNERS, AGENTS, EMPLOYEES, REPRESENTATIVES, SUBSIDIARIES,
              AFFILIATES, SUCCESSORS, TRUSTEES, ASSIGNS, TRANSFEREES,
              35789369v.1 CONTRACTORS, VENDORS, OR LICENSEES OR (B) EXERCISE ANY
              OF THE RIGHTS OR PRIVILEGES GRANTED OR CONVEYED BY YOU UNDER THIS
              AGREEMENT (INCLUDING, WITHOUT LIMITATION, THE USER MATERIALS).
            </p>
            <p>
              YOU ALSO HEREBY WAIVE ANY RIGHTS YOU MAY HAVE UNDER SECTION 1542
              OF THE CALIFORNIA CIVIL CODE AND ANY OTHER STATUTE OR COMMON LAW
              PRINCIPLE OF SIMILAR EFFECT, WHICH PROVIDES:
            </p>
            <p>
              <i>
                “A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS THAT THE CREDITOR
                OR RELEASING PARTY DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR
                HER FAVOR AT THE TIME OF EXECUTING THE RELEASE AND THAT, IF
                KNOWN BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED HIS OR HER
                SETTLEMENT WITH THE DEBTOR OR RELEASED PARTY.”
              </i>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Indemnification.</strong> YOU
              HEREBY AGREE TO INDEMNIFY, RELEASE, AND HOLD HARMLESS COMPANY,
              COMPANY’S SUBSIDIARIES AND OTHER AFFILIATES, AND THEIR RESPECTIVE
              OFFICERS, DIRECTORS, MANAGERS, OWNERS, PARTNERS, AGENTS,
              EMPLOYEES, REPRESENTATIVES, TRUSTEES, ASSIGNS, TRANSFEREES,
              CONTRACTORS, VENDORS, AND LICENSEES FROM AND AGAINST ANY AND ALL
              LIABILITIES, CLAIMS, SUITS, DEMANDS, ACTIONS, JUDGMENTS, LOSSES,
              DAMAGES, FINES, PENALTIES, AND EXPENSES (INCLUDING COSTS AND
              REASONABLE OUTSIDE ATTORNEY FEES) INCURRED BY SUCH INDEMNITEES, OR
              ASSERTED AGAINST SUCH INDEMNITEES BY THIRD PARTIES, ARISING OUT OF
              OR IN CONNECTION WITH (A) YOUR ACTS, ERRORS, OR OMISSIONS, (B)
              YOUR USE OF THE PLATFORM OR ANY PRODUCTS OR SERVICES MADE
              AVAILABLE ON, THROUGH, OR IN RELATION TO THE PLATFORM (INCLUDING,
              WITHOUT LIMITATION, THE SERVICES) IN ANY MANNER CONTRARY TO THE
              TERMS AND CONDITIONS OF THIS AGREEMENT, (C) YOUR VIOLATION OF THE
              RIGHTS OF OR OTHER INJURY TO ANY THIRD PARTY, AND/OR (D) YOUR
              BREACH OF ALL OR ANY PART OF THIS AGREEMENT.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Governing Law. </strong> This
              Agreement, the additional terms, conditions, and policies
              referenced herein (including the Platform’s Privacy Policy), your
              access or use of the Platform or any Services, your registration
              with the Platform, any transactions made on, through, or in
              relation to the Platform, any products or services purchased on,
              through, or in relation to the Platform (including, without
              limitation, the Services), the Parties’ relationship, and all
              disputes, controversies, and claims arising from or in connection
              with any of the foregoing (whether grounded in contract, tort,
              statute, law, or equity) is governed by the laws of the State of
              Texas in the United States of America and the applicable federal
              laws of the United States of America, regardless of its place of
              execution, its place of performance, and any conflicts of law
              analysis.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Dispute Resolution.</strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">
                      Binding Arbitration; Waiver.
                    </span>{" "}
                    Each Party hereby irrevocably submits all disputes,
                    controversies and claims arising from or concerning this
                    Agreement, any additional terms, conditions or policies
                    referenced in this Agreement (including the Platform’s
                    Privacy Policy), your access or use of the Platform or the
                    Services, any transactions made on, through, or in relation
                    to the Platform, any products or services purchased on,
                    through, or in relation to the Platform (including, without
                    limitation, the Services), and/or the Parties’ relationship
                    (whether grounded in contract, tort, statute, law, or
                    equity) (collectively, the “Dispute(s)”) to binding
                    arbitration administered by Judicial Arbitration and
                    Mediation 35789369v.1 Services, Inc. (a/k/a JAMS) or its
                    successor (<strong>“JAMS”</strong>) for the resolution
                    thereof, and such arbitration shall be the sole and
                    exclusive method for resolving the Disputes. The arbitration
                    shall be binding, final, and confidential. EACH PARTY
                    ACKNOWLEDGES AND AGREES THAT SUCH PARTY IS WAIVING THE RIGHT
                    TO A TRIAL BY JURY OR TO PARTICIPATE AS THE MEMBER OF A
                    CLASS IN ANY PURPORTED CLASS ACTION PROCEEDING.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Arbitration Rules.</span> The
                    arbitration shall be conducted before a single arbitrator
                    under the then-current JAMS Comprehensive Arbitration Rules
                    & Procedures (the <strong>“JAMS Rules”</strong>), as
                    supplemented by the Federal Rules of Civil Procedure and the
                    Federal Rules of Evidence if and where applicable as a
                    gap-filler. If there is any conflict between a provision of
                    the JAMS Rules, the Federal Rules of Civil Procedure, the
                    Federal Rules of Evidence, or this Agreement, then the
                    conflicting provision of this Agreement shall control and
                    govern over the JAMS Rules, the Federal Rules of Civil
                    Procedure and the Federal Rules of Evidence, and the JAMS
                    Rules shall control and govern over the Federal Rules of
                    Civil Procedure and the Federal Rules of Evidence. The
                    construction, interpretation, and enforcement of this{" "}
                    <span className="t-underline">Section 19</span> is governed
                    by the Federal Arbitration Act, 9 U.S.C. §§ 1 <i>et seq</i>.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Arbitration Process, Location, and Procedures.
                    </span>{" "}
                    The Party initiating the arbitration proceeding shall serve
                    a written notice of arbitration on the other Party in
                    accordance with the JAMS Rules. The arbitration shall be
                    held in Travis County, Texas, United States of America. The
                    arbitration shall be conducted in the English language. The
                    arbitrator shall be selected in accordance with the JAMS
                    Rules, unless otherwise agreed to by the parties to the
                    arbitration. All issues or questions concerning either the
                    scope of this arbitration clause or the arbitrability of any
                    of the Disputes shall be referred to and finally decided by
                    the arbitrator. The arbitrator may construe or interpret,
                    but shall not vary or ignore, the terms and conditions of
                    this Agreement and shall be bound by applicable law.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Arbitration Decisions and Awards.
                    </span>{" "}
                    The arbitrator shall render a written final decision on the
                    subject Dispute as soon as practicable and, in any event,
                    not more than 45 calendar days after the close of evidence
                    and briefing. The arbitrator’s decision shall be written,
                    shall be in accordance with applicable law, and shall be
                    supported by written findings of fact and conclusions of law
                    setting forth the basis for the arbitrator’s decision. The
                    arbitrator shall have no authority to award punitive,
                    exemplary, or consequential damages, unless such an award is
                    authorized by applicable law. The arbitrator shall have the
                    authority to award attorneys’ fees and expenses if such an
                    award is permitted under this Agreement or applicable law.
                    Subject to any applicable rights of appeal, the final
                    decision of the arbitrator shall be binding and conclusive
                    upon all of the Parties who have been served with proper
                    written notice of the arbitration proceeding as required by
                    this Section 19. Judgment on any award rendered by the
                    arbitrator may be confirmed in any state or federal court
                    having jurisdiction thereof that is located in the State of
                    Texas, United States of America, and may be entered in and
                    enforced by any domestic, foreign, or international court
                    having appropriate subject matter jurisdiction. Any
                    decision, judgment, ruling, finding, award, or other
                    determination of the arbitrator and any information
                    disclosed in the course of any arbitration hereunder shall
                    be kept confidential by the Parties, and any court order to
                    enforce the decision, judgment, ruling, finding, award, or
                    other determination of the arbitrator shall be filed under
                    seal.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Arbitration Fees and Expenses.
                    </span>{" "}
                    JAMS’s administrative and filing fees, the arbitrator’s fees
                    and expenses and all other fees and expenses charged by JAMS
                    and/or the arbitrator to administer or conduct the
                    arbitration shall be shared equally among all parties to the
                    arbitration; provided, that the prevailing party of the
                    arbitration may recover an award of its share of such fees
                    and expenses if such an award is permitted under this
                    Agreement or applicable law
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Litigation; Waiver.</span> In
                    the event a particular Dispute is not subject to arbitration
                    (whether by decision of an arbitrator with binding
                    authority, or otherwise according to this Agreement or
                    applicable law), each Party hereby irrevocably submits to
                    the exclusive personal jurisdiction and venue of the state
                    courts of Travis County, Texas, United States of America and
                    the United States federal courts in the Western District of
                    Texas, Austin Division, for the litigation of said Dispute,
                    and covenant and agree that neither of the foregoing is an
                    inconvenient venue or forum.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Waiver of Jury Trial and Class Action.
                    </span>{" "}
                    REGARDLESS OF WHETHER A PARTICULAR DISPUTE IS SUBJECT TO
                    ARBITRATION OR LITIGATION, AND TO THE FULLEST EXTENT
                    PERMITTED BY LAW, EACH PARTY DOES HEREBY WAIVE HIS/HER/ITS
                    RIGHT TO A TRIAL BY JURY, TO PARTICIPATE AS THE MEMBER OF A
                    CLASS IN ANY PURPORTED CLASS ACTION OR OTHER PROCEEDING, OR
                    TO NAME UNNAMED MEMBERS IN ANY PURPORTED CLASS ACTION OR
                    OTHER PROCEEDING.
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">
                Additional Terms Regarding This Agreement and Apple.{" "}
              </strong>
              The following addresses certain matters with respect to Apple Inc.
              (<strong>“Apple”</strong>) and the usage rules (the{" "}
              <strong>“Usage Rules”</strong>) set forth in Apple’s App Store
              Terms and Conditions (located at{" "}
              <a
                className="hyperlink"
                href="http://www.apple.com/legal/internetservices/itunes/us/terms.html"
              >
                http://www.apple.com/legal/internetservices/itunes/us/terms.html
              </a>
              ). The Parties hereby acknowledge and agree that: (a) this
              Agreement is between the Parties only and not with Apple; (b)
              Apple is not responsible for the Platform or the content thereof;
              (c) Apple has no obligation whatsoever to furnish any maintenance
              and support services with respect to the Platform; (d) Apple is
              not responsible for addressing any claims you or any third party
              have or may have relating to the Platform or your possession
              and/or use of the Platform, including, without limitation (i)
              product liability claims, (ii) any claim that the Platform fails
              to conform to any applicable legal or regulatory requirement,
              (iii) claims arising under consumer protection or similar
              legislation, and (iv) intellectual property infringement claims;
              (e) this Agreement and the usage rules for the Platform are not
              intended to be less restrictive than Apple’s Usage Rules; (f)
              Apple and Apple’s subsidiaries are third-party beneficiaries of
              this Agreement; and (g) upon your acceptance of this Agreement,
              Apple will have the right (and will be deemed to have accepted the
              right) to enforce this Agreement against you as a third-party
              beneficiary hereof.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">General Provisions.</strong>
              <ol type="a" id="list-lower-alpha">
                <li>
                  <p>
                    <span className="t-underline">Notice.</span> Unless
                    otherwise expressly stated in this Agreement, Company may
                    give or deliver all other notices to you by means of a
                    general notice posted on this or another page of the
                    Platform, as applicable, or by e-mail to your e-mail address
                    as you may provide to Company on or through the Platform,
                    and such notices shall be deemed effective as of their
                    stated effective dates.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Relationship.</span> In no
                    event shall this Agreement, the performance of a Party’s
                    rights or obligations under this Agreement, the Platform, or
                    a Party’s access or use of the Platform or the Services
                    create any type of fiduciary, franchise, agency, employment,
                    independent contractor, partnership, or joint venture
                    relationship between you and Company.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Force Majeure.</span> Company
                    shall not be liable for delays in performance caused by any
                    act of God, fire or other casualty, accident, strike,
                    shortage of labor or materials, governmental action,
                    industrial disturbance, pandemic, epidemic, or any other
                    cause beyond Company’s reasonable control, and the time for
                    Company’s performance shall be extended by the period of any
                    such delay. Company reserves the right to apportion its
                    production among its customers as it may determine.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Termination; Survival.</span>{" "}
                    . If this Agreement is terminated for any or no reason, then
                    all rights granted to you under this Agreement shall
                    automatically revert back to Company, and the following
                    shall survive in perpetuity: (i) all defined terms under
                    this Agreement; (ii) all rights and privileges under this
                    Agreement which were granted to or accrued in favor of
                    Company, any of Company’s subsidiaries or other affiliates,
                    or any of their respective officers, directors, managers,
                    owners, partners, agents, employees, representatives,
                    trustees, assigns, transferees, contractors, vendors, or
                    licensees as of the date of this Agreement’s termination;
                    (iii) all payments which accrued as of the date of
                    termination; (iv) all disclaimers, limitations of liability
                    and limitations of remedies; and (v) all representations,
                    warranties, covenants, certifications, releases,
                    indemnifications, and promises made by you under this
                    Agreement.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Electronic Signatures.</span>{" "}
                    IF YOUR ACCEPTANCE OF THIS AGREEMENT IS FURTHER EVIDENCED BY
                    YOUR AFFIRMATIVE ASSENT TO THE SAME (E.G., BY A “CHECK THE
                    BOX” ACKNOWLEDGMENT PROCEDURE), THEN THAT AFFIRMATIVE ASSENT
                    IS THE EQUIVALENT OF YOUR ELECTRONIC SIGNATURE TO THIS
                    AGREEMENT. HOWEVER, FOR THE AVOIDANCE OF DOUBT, YOUR
                    ELECTRONIC SIGNATURE IS NOT REQUIRED TO EVIDENCE OR
                    FACILITATE YOUR ACCEPTANCE AND AGREEMENT TO THIS AGREEMENT,
                    AS YOU AGREE THAT THE CONDUCT DESCRIBED IN THIS AGREEMENT AS
                    RELATING TO YOUR ACCEPTANCE AND AGREEMENT TO THIS AGREEMENT
                    ALONE SUFFICES.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">No Waiver.</span> No failure
                    or delay to exercise any right, remedy, power, or privilege
                    arising from or in connection with this Agreement will
                    operate or be construed as a waiver thereof, except as
                    otherwise expressly stated in this Agreement. Any waiver
                    authorized on one occasion is effective only in that
                    instance and only for the purpose stated, and does not
                    operate as a waiver on any future occasion.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Assignment and Delegation.
                    </span>{" "}
                    You shall not assign, delegate, or otherwise transfer any of
                    your rights or obligations under this Agreement without
                    Company’s prior written consent in each instance.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">
                      Construction and Interpretation.
                    </span>{" "}
                    This Agreement shall be construed to have been drafted by
                    all of the Parties, so that any rule of construction or
                    interpretation that construes or interprets ambiguities
                    against the drafter shall have no force or effect.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Headings.</span> Section
                    headings are inserted in this Agreement for reference and
                    convenience only and shall not interpret, define, limit, or
                    describe the scope, intent, terms, or conditions of this
                    Agreement.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Severability.</span> If any
                    term or condition of this Agreement is deemed invalid or
                    unenforceable by the arbitrator or (if applicable) a court
                    of law with binding authority, then the remaining terms and
                    conditions shall not be affected, and said arbitrator or
                    court of law shall reform the invalidated or unenforceable
                    term or condition to the maximum extent permitted under the
                    law and consistent with the intent of this Agreement.
                  </p>
                </li>
                <li>
                  <p>
                    <span className="t-underline">Entire Agreement.</span> This
                    Agreement, together with those additional terms, conditions,
                    and policies referenced herein and/or made available herein
                    by hyperlink (including the Platform’s Privacy Policy),
                    constitutes the entire agreement and understanding between
                    the Parties with respect to the subject matter hereof,
                    supersedes any prior agreements and understandings, if any,
                    between the Parties with respect to such subject matter, and
                    shall inure to the benefit of and be binding upon the
                    Parties and their respective successors and assigns.
                  </p>
                </li>
              </ol>
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Contact Us.</strong> Please direct
              any questions you may have about the Platform or this Agreement to{" "}
              <a className="hyperlink" href="mailto:privacy@atlas.energy">
                privacy@atlas.energy
              </a>{" "}
              with a subject line of “Platform Question.” The foregoing contact
              information may change from time to time by supplementation,
              amendment, or modification of this Agreement.
            </p>
          </li>
          <li>
            <p>
              <strong className="t-underline">Modification Date.</strong> This
              Agreement was last updated on April 4, 2023
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default TermsOfUsage;
